import { styled } from 'styled-components';

import { useState } from 'react';

import SmallButton from '@src/components/styled/SmallButton';
import Input from '@src/components/ChatWidget/Input';

import ChatRow from './ChatRow';
import { ChatMessage } from '@src/lib/types';

import _chat from '@src/io/events_out/_chat';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: 1rem;
  max-width: 20rem;

  // background color rgba gray with half opacity
  background-color: rgba(192, 192, 192, 0.5);
  border: solid gray 2px;

  // min-height: 30rem;
  max-height: 25rem;
  min-height: 25rem;

  width: 100%;
  height: 100%;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  margin-bottom: 0.5rem;

  ${Input} {
    max-width: 12.8rem;
  }

  ${SmallButton} {
    padding: 0.25rem 0.25rem;
    margin: 0;
  }
`;

const MessagesContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column-reverse;

  padding-top: 10pt;
  padding-left: 10pt;
  padding-right: 10pt;
  margin-bottom: 5pt;

  overflow-y: scroll;
  overflow-x: hidden;
`;

type Props = {
  gameId?: string;
  room?: string;
  chatMessages: ChatMessage[];
};

export default function ChatBox(props: Props) {
  const [chatMessage, setChatMessage] = useState('');

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value.length > 140) return;
    setChatMessage(event.target.value);
  };

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!chatMessage.trim()) return;
    _chat({
      room: props.room,
      gameId: props.gameId,
      message: chatMessage,
    });
    setChatMessage('');
  };

  return (
    <Container>
      <MessagesContainer>
        {props.chatMessages
          .slice(0)
          .reverse()
          .map((chatMessage, index) => {
            return (
              <ChatRow
                key={index}
                name={chatMessage.playerName}
                message={chatMessage.message}
              />
            );
          })}
      </MessagesContainer>
      <form onSubmit={handleOnSubmit}>
        <InputContainer>
          <Input onChange={handleOnChange} value={chatMessage} />
          <SmallButton type='submit'>Send</SmallButton>
        </InputContainer>
      </form>
    </Container>
  );
}
